export enum EComandaMesaEstado {
  LIBRE,
  OCUPADA,
  RESERVADA,
}
export enum EComandaProductoEstado {
  PENDIENTE,
  EN_PREPARACION,
  LISTO,
  ENTREGADO,
  CANCELADO,
}
